import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as invoiceAction from '../actions/invoice.action';
import {map, switchMap, catchError, mergeMap, take, withLatestFrom, filter} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import * as fromStore from '../../../store';
import {isNullOrUndefined} from 'util';
import {InvoiceService} from '../../invoice.service';



@Injectable()
export class InvoiceEffects {
  constructor(private actions: Actions,
              private invoiceService: InvoiceService,
              private store: Store<fromStore.AppState>) {
  }

  @Effect()
  getAllInvoices: Observable<Action> = this.actions.ofType(invoiceAction.GET_ALL_INVOICES)
    .pipe(
      switchMap(() => {
        return this.invoiceService.getAllInvoices()
          .map(res => {
            res.map(i => this.updateMarkPaid(i));
            return new invoiceAction.GetAllInvoicesSuccess(res);
          })
          .catch(error => of(new invoiceAction.GetAllInvoicesError(error)));
      })
    );

  @Effect()
  updateInvoice: Observable<Action> = this.actions.ofType(invoiceAction.UPDATE_INVOICE)
    .map((action: invoiceAction.UpdateInvoice) => action.payload)
    .pipe(
      switchMap(body => {
        return this.invoiceService.updateInvoice(body)
          .map(res => {
            return new invoiceAction.UpdateInvoiceSuccess(this.updateMarkPaid(res));
          })
          .catch(error => of(new invoiceAction.UpdateInvoiceError(error)));
      })
    );

  @Effect()
  approveInvoice: Observable<Action> = this.actions.ofType(invoiceAction.APPROVE_INVOICE_PAYMENT)
    .map((action: invoiceAction.ApproveInvoicePayment) => action.payload)
    .pipe(
      switchMap(body => {
        return this.invoiceService.approveInvoice(body)
          .map(res => new invoiceAction.ApproveInvoicePaymentSuccess(res))
          .catch(error => of(new invoiceAction.ApproveInvoicePaymentError(error)));
      })
    );

  private updateMarkPaid(i) {
    if (i.markAsPaid === true) {
      i.invoicePaid = 'true';
    }
    if (!i.brandApproval) {
      i.invoicePaid = 'before';
    }
    if (i.markAsPaid === false && i.brandApproval === true) {
      i.invoicePaid = 'admin';
    }
    if (i.markAsPaid === false && i.brandApproval === true && i.pending === true) {
      i.invoicePaid = 'pending';
    }
    if (i.brandApproval === false && i.markAsPaid === false) {
      i.invoicePaid = 'false';
    }
    return i;
  }
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/invoices/store/effects/invoice.effect.ts